import TagManager from 'react-gtm-module'

const isGtmInitialized = () => !!(window as any).dataLayer

const pushEvent = (name: string, args?: Record<string, any>) => {
  const intervalId = setInterval(() => {
    if (isGtmInitialized()) {
      clearInterval(intervalId)
      TagManager.dataLayer({
        dataLayer: {
          event: name,
          ...args,
        },
      })
    } else {
      console.log('gtm not initialized yet, postponing')
    }
  }, 200)
}

export const gtm = {
  pushEvent,
}
